import React, {Component} from 'react';

import {Navigate} from "react-router-dom";

import {Alert} from "reactstrap"

import 'typeface-titillium-web';
import {SPIDReactButton} from '@dej611/spid-react-button'
import '@dej611/spid-react-button/dist/index.css'
import {AuthAPI} from "../api";

import {Utils} from "../services";
import {metodiAttivi, passwordAttivo, spidOldAttivo, SPID, URL_IDENTITA_DIGITALE, mostraIstruzioniCns} from "../config/loginMetodi";




class LoginButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                fiscal_code: "",
                password: ""
            },
            error: null,
            authenticated: false,
            loading: false
        }
    }


    onChangeForm(key, e) {
        const form = this.state.form;
        form[key] = e.target.value;
        this.setState({form: form}, () => this.showModalLogin());
    }


    doLogin() {

        const self = this;

        let form = this.state.form;
        let error = null;
        if (form.password === "") {
            error = "La password non può essere vuota";
        }

        if (form.fiscal_code.length === 16) {
            if (form.fiscal_code !== "" && !Utils.isValidFiscalCode(form.fiscal_code)) {
                error = 'Il codice fiscale inserito non è valido';
            }
        }

        if (form.fiscal_code === "") {
            error = 'Inserisci il tuo codice fiscale o username per continuare';
        }

        this.setState({error: error}, () => this.showModalLogin());

        if (error === null) {
            this.setState({loading: true}, () => this.showModalLogin());
            AuthAPI.login(this.state.form).then((user) => {
                this.setState({authenticated: true});
                window.onSetModal({loading: false, content: "", isOpen: false});
                window.SweetAlert.fire({
                    title: 'Bentornato,' + `${user.firstname ?? ''} ${user.lastname ?? ''}`+ "!",
                    text: '',
                    icon: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                }).then(function (result) {
                    if (Utils.isOperator()) {
                        window.location.assign(process.env.REACT_APP_FRONTEND_URL + "/" + window.municipalityData.string + "/dashboard");
                    } else {
                        window.location.reload();
                    };

                });
            }).catch((error) => {
                console.error('Login failed:', error);
                let errorMessage = "Accesso negato";
                
                if (error && error.error === "INVALID_SESSION_TOKEN") {
                    errorMessage = "Errore del server: token di sessione non valido. Contatta l'assistenza.";
                    console.error('Server returned null session token');
                } else if (error && error.message) {
                    errorMessage = error.message;
                }
                
                this.setState({loading: false, error: errorMessage}, () => this.showModalLogin());
            });
        }
    }


    // Pulsante "Entra con ..." come nella Discovery Page IT-Wallet (config/loginMetodi.js)
    pulsanteMetodo(m) {
        return (
            <div className="login-metodo" key={m.metodo}>
                <a className={"login-metodo-btn login-metodo-" + m.metodo} href={m.url}
                   onClick={m.metodo === 'cns' ? (e) => { e.preventDefault(); mostraIstruzioniCns(); } : undefined}>
                    <img className="login-metodo-logo" src={m.logo} alt="" />
                    <span className="login-metodo-separatore" aria-hidden="true" />
                    <span className="login-metodo-etichetta">{m.etichetta}</span>
                </a>
                {this.scopriDiPiu(m)}
            </div>
        );
    }

    scopriDiPiu(m) {
        return (
            <details className="login-metodo-info">
                <summary>Scopri di più</summary>
                <p>{m.descrizione}</p>
                {m.link ? <a href={m.link} target="_blank" rel="noopener noreferrer">
                    {m.linkEtichetta}<span className="sr-only"> (si apre in una nuova finestra)</span>
                </a> : null}
            </details>
        );
    }

    showModalLogin(){
        const municipality = this.props.municipality;
        
        let form = this.state.form;
        let errors = this.state.errors;
        let app_aggregator_url = 'https://utd-' + window.getMunicipalityString().replace('_','-') + '.megtributi.it';
        console.log(app_aggregator_url);
        const digitale = spidOldAttivo() || metodiAttivi('digitale').length > 0;
        const alternativi = metodiAttivi('alternativo');

        window.onSetModal({
            content: <div className="login-modal-main">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <div className="row">
                                <div className="heading">
                                    <h3>Accesso Contribuente</h3>
                                    <p>Accedi per consultare la tua posizione contributiva ed ulteriori servizi</p>
                                </div>
                                {digitale ? <div className="login-sezione">
                                <h4 className="login-sezione-titolo">Accedi con un'identità digitale</h4>
                                {metodiAttivi('digitale').map((m) => this.pulsanteMetodo(m))}
                                {spidOldAttivo() ? <div className="login-metodo"><div className="spid-button">
                                    <SPIDReactButton 
                                        url={app_aggregator_url + "/servizispid/LoginSPID?entityID={{idp}}&target=" + app_aggregator_url + "/site/" + window.getMunicipalityString() + "?loginspid=true&authnContextClassRef=https://www.spid.gov.it/SpidL2"}
                                        method={"GET"}
                                        supported={[
                                            "https://loginspid.aruba.it",
                                            "https://identity.infocert.it",
                                            "https://spid.intesa.it",
                                            "https://id.lepida.it/idp/shibboleth",
                                            "https://idp.namirialtsp.com/idp",
                                            "https://posteid.poste.it",
                                            "https://spid.register.it",
                                            "https://spid.teamsystem.com/idp",
                                            "https://identity.sieltecloud.it",
                                            "https://login.id.tim.it/affwebservices/public/saml2sso"
                                        ]}
                                        // corners={"sharp"}
                                        // supported={[
                                        //     "https://demo.spid.gov.it/validator"
                                        // ]}
                                        // extraProviders={[
                                        //     {
                                        //         "entityID": "https://demo.spid.gov.it/validator",
                                        //         "entityName": "Test IdP"
                                        //     }
                                        // ]}
                                        protocol="SAML"
                                        fluid={true}
                                        corners="sharp"
                                    />
                                </div>{this.scopriDiPiu(SPID)}</div> : null}
                                <div className="login-senza-identita">
                                    <p>Non hai un'identità digitale?</p>
                                    <a href={URL_IDENTITA_DIGITALE} target="_blank" rel="noopener noreferrer">
                                        Scopri come ottenerla<span className="sr-only"> (si apre in una nuova finestra)</span>
                                    </a>
                                </div>
                                </div> : null}
                                {(alternativi.length > 0 || passwordAttivo()) ? <div className="login-sezione">
                                {(digitale || alternativi.length > 0) ? <h4 className="login-sezione-titolo">Accedi con un metodo alternativo</h4> : null}
                                {alternativi.map((m) => this.pulsanteMetodo(m))}
                                {passwordAttivo() ? <React.Fragment>
                                {alternativi.length > 0 ? <div className="or-devider">
                                    <span>oppure</span>
                                </div> : null}
                                <div className="form-group">
                                    <label className="label">Codice Fiscale / username</label>
                                    <input type="text" value={this.state.form.fiscal_code} className="form-control" onChange={(e) => this.onChangeForm('fiscal_code', e)}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="password" className="label">Password</label>
                                    <div className="position-relative">
                                        <input type="password" value={this.state.form.password} className="form-control" id="password" onChange={(e) => this.onChangeForm('password', e)}/>
                                    </div>
                                </div>
                                {(this.state.error !== null) ? <Alert color="danger">{this.state.error}</Alert> : null}
                                <div className="form-group d-flex flex-wrap justify-content-between">
                                    <a href="#" className="font-size-3 text-dodger line-height-reset">Password dimenticata?</a>
                                </div>
                                <div className="form-group mb-8 button">
                                    <button className="btn " onClick={(e) => this.doLogin(e)}>
                                         {(this.state.loading) ? <i className="fa fa-lg fa-spin fa-spinner" /> : "Accedi" }
                                    </button>
                                </div>
                                {   
                                    ((this.props.municipality.email != null) && (this.props.municipality.telefono != null)) ?
                                    (<p className="text-center create-new-account">
                                        {/* Non hai un account?<br />Contatta <a href={'mailto:' + process.env.REACT_APP_EMAIL_ASSISTANCE}>{process.env.REACT_APP_EMAIL_ASSISTANCE}</a> per creare un account */}
                                        Non hai un account?
                                        <br />Contatta l'indirizzo <a href={'mailto:' + this.props.municipality.email}>{this.props.municipality.email}</a> oppure il numero <a href={'tel:' + this.props.municipality.telefono}>{this.props.municipality.telefono}</a> per creare un account
                                    </p>) : null
                                }
                                {   
                                    ((this.props.municipality.email != null) && (this.props.municipality.telefono == null)) ?
                                    (<p className="text-center create-new-account">
                                        Non hai un account?
                                        <br />Contatta l'indirizzo <a href={'mailto:' + this.props.municipality.email}>{this.props.municipality.email}</a>
                                    </p>) : null
                                }
                                {   
                                    ((this.props.municipality.email == null) && (this.props.municipality.telefono != null)) ?
                                    (<p className="text-center create-new-account">
                                        Non hai un account?
                                        <br />Contatta il numero <a href={'tel:' + this.props.municipality.telefono}>{this.props.municipality.telefono}</a> per creare un account
                                    </p>) : null
                                }
                                </React.Fragment> : null}
                                </div> : null}

                            </div>
                        </div>
                    </div>
                </div>,
            isOpen: true,
            toggle: true,
            size: 'sm',
            type: 'info',
            buttons: []
        })
    }

    render() {
        if (this.state.authenticated)
            return <Navigate to={"/site/" + window.getMunicipalityString()}/>

        return <a className="login" style={{cursor: "pointer"}} onClick={() => this.setState({loading: false, error: null}, () => this.showModalLogin())}>
                <i className="lni lni-lock-alt" /> Login
        </a>;
    }
}

export default LoginButton;
